import FetchFactory from '@repository/factory';
import Routes from '@repository/routes.client';
import type { LocationQueryValue } from 'vue-router';
import type {
    UserDetails,
    DetailsResponse,
    UserPreferences,
    CloseAccountResponse,
    UpdateDetailsResponse,
    PossibleUserPreferences,
    DecodedDetailsResponse,
} from '@repository/types';

class UserModule extends FetchFactory {
    private readonly RESOURCE = Routes.User;

    getDetails() {
        return this.call<DetailsResponse>({
            url: `${this.RESOURCE.details()}`,
            method: 'GET',
        });
    }

    updateDetails(payload: UserDetails) {
        return this.call<UpdateDetailsResponse>({
            url: `${this.RESOURCE.details()}`,
            method: 'PUT',
            body: payload,
        });
    }

    closeAccount() {
        return this.call<CloseAccountResponse>({
            url: `${this.RESOURCE.closeAccount()}`,
            method: 'DELETE',
        });
    }

    getPreferences() {
        return this.call<PossibleUserPreferences>({
            url: `${this.RESOURCE.preferences()}`,
            method: 'GET',
        });
    }

    savePreferences(payload: Partial<UserPreferences>) {
        return this.call({
            url: `${this.RESOURCE.preferences()}`,
            method: 'POST',
            body: payload,
        });
    }

    getDecodedDetails(
        registrationParam: MaybeRef<
            LocationQueryValue | LocationQueryValue[] | string
        >
    ) {
        return this.call<DecodedDetailsResponse>({
            url: `${this.RESOURCE.registerDecode()}`,
            method: 'GET',
            fetchOptions: {
                query: { registrationParam: toValue(registrationParam) },
            },
        });
    }
}

export default UserModule;
